import React, { useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";

import { onDragEnd, onDragEndMultiple, onDragUpdate } from "../../helpers";
import DroppableWrapper from "./DroppableWrapper";
import { StyledDroppablesContainer } from "./styles";
import { useHubSnackBar } from "../../hooks";

export const DraggableWrapper = ({
  droppableId = "droppable",
  elements = [],
  onChange = () => {},
  disablePlaceholder = false,
  includeSnapshot = false,
  Component,
  StartComponent,
  customDroppableProps = {},
  direction = "vertical",
  ...rest
}) => {
  const [placeholderProps, setPlaceholderProps] = useState(false);

  const handleOnChange = (changed, dragInfo) => {
    onChange(changed, dragInfo);
    setPlaceholderProps(false);
  };

  const isMultiDrop = Array.isArray(elements[0]?.elements);
  const { addSnackbarError } = useHubSnackBar();
  const handleDragEnd = (result) => {
    setPlaceholderProps(false);
    return isMultiDrop
      ? onDragEndMultiple(result, {
          elements,
          onChange: handleOnChange,
          addSnackbarError,
        })
      : onDragEnd({ elements, result, onChange: handleOnChange });
  };

  const handleOnDragUpdate = (update) =>
    !disablePlaceholder &&
    onDragUpdate({ update, onChange: setPlaceholderProps });

  const sharedDroppableProps = {
    includeSnapshot,
    placeholderProps,
    disablePlaceholder,
    customDroppableProps,
    Component,
    direction,
  };
  return (
    <StyledDroppablesContainer
      className="HubDroppablesContainer-root"
      {...rest}
    >
      <DragDropContext
        onDragEnd={handleDragEnd}
        onDragUpdate={handleOnDragUpdate}
      >
        {isMultiDrop ? (
          elements?.map((element) => (
            <DroppableWrapper
              key={element.id}
              droppableId={element.id}
              elements={element?.elements}
              column={element}
              StartComponent={StartComponent}
              {...sharedDroppableProps}
            />
          ))
        ) : (
          <DroppableWrapper
            droppableId={droppableId}
            elements={elements}
            StartComponent={StartComponent}
            {...sharedDroppableProps}
          />
        )}
      </DragDropContext>
    </StyledDroppablesContainer>
  );
};

export default DraggableWrapper;
